/**
 * Who can use the Film Desk, in one place for the sidebar tile and the server
 * (api/_filmdesk/access.js). Three ways in: a BAM admin, an active remote film
 * intern (the Intern Hub enrollment), or a contributor given it by hand
 * (profiles.allowlist_features includes "filmdesk", managed from the Film Desk's
 * Contributors panel). Contributors help find clips without being enrolled as
 * interns (Coleman, 2026-11-02).
 *
 * Pure: no React, no Supabase, so the server can import it too.
 */
export const FILMDESK_FEATURE = "filmdesk";

/** Does this allowlist give the Film Desk? */
export const hasFilmDeskFeature = (allowlist) =>
  Array.isArray(allowlist) && allowlist.includes(FILMDESK_FEATURE);

/** Is this person a remote film intern? (an enrollment row, or the client's intern access object) */
export const isRemoteIntern = (enrollment) =>
  !!enrollment && enrollment.program === "remote" && (enrollment.status == null || enrollment.status === "active");

/** Can this person open and contribute to the Film Desk? */
export function canUseFilmDesk({ admin = false, enrollment = null, allowlist = null } = {}) {
  return !!admin || isRemoteIntern(enrollment) || hasFilmDeskFeature(allowlist);
}
